export const koFindCorporationGuide: {
  title: string;
  description: string;
  name: "email" | "phoneNumber";
}[] = [
  {
    title: "이메일 인증",
    description: "아래에 이메일 주소를 입력하시면 이메일로 인증 링크를 전송해드립니다.",
    name: "email",
  },
  {
    title: "문자 인증",
    description: "아래에 담당자 휴대폰 번호를 입력하시면 문자로 인증 링크를 전송해드립니다.",
    name: "phoneNumber",
  },
];

export const enFindCorporationGuide: {
  title: string;
  description: string;
  name: "email" | "phoneNumber";
}[] = [
  {
    title: "E-mail Verification",
    description: "Enter your registered email to receive a verification email.",
    name: "email",
  },
  {
    title: "SMS Verification",
    description: "Enter your registered mobile number to receive a verification message.",
    name: "phoneNumber",
  },
];
